export default "__VITE_ASSET__D_K$NjLI__"